import { render, staticRenderFns } from "./supplier-info-add-or-update.vue?vue&type=template&id=59337992"
import script from "./supplier-info-add-or-update.vue?vue&type=script&lang=js"
export * from "./supplier-info-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./supplier-info-add-or-update.vue?vue&type=style&index=0&id=59337992&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports